// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__zd9fK","title":"card_title__1a7ms","inActive":"card_inActive__DSJhz"};